var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileNavContactUs = function SvgMobileNavContactUs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 44 44"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "mobile-nav-contact-us_svg__a",
    d: "M0 0h44v44H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mobile-nav-contact-us_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mobile-nav-contact-us_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.5,
    mask: "url(#mobile-nav-contact-us_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.798 22.2c5.424 0 9.821-4.397 9.821-9.821V9.82C22.619 4.397 18.222 0 12.798 0 7.373 0 2.976 4.397 2.976 9.821v.197"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.952,
    height: 8.4,
    y: 10.2,
    fill: "#F5F5F5",
    rx: 2.976
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.952,
    height: 3.6,
    x: 9.524,
    y: 20.4,
    fill: "#F5F5F5",
    rx: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.952,
    height: 8.4,
    x: 19.048,
    y: 10.2,
    fill: "#F5F5F5",
    rx: 2.976
  }))))));
};
export default SvgMobileNavContactUs;